module.exports = "img/taller-alm-2.26f4d9.jpg";